// extracted by mini-css-extract-plugin
export default {"root":"Vlp7Nx","title":"Jn4xo_","description":"BmbDH9","resetLink":"f2s6xl","searchFadeIn":"EdrEpe"};